import react from "react";
import { useDispatch,useSelector  } from "react-redux";
import { IoIosClose } from "react-icons/io";
import { hidePopup } from "../../Store/reducers/popUpSlice";

const Popup = () => {
  const dispatch = useDispatch();
  const { visible, message } = useSelector((state) => state.popup);
  if (!visible) return null;





  
  return (
    <div
      className={`fixed inset-0 flex items-center justify-center cursor-pointer z-[200] ${"bg-black bg-opacity-50"}`}
      onClick={() => dispatch(hidePopup())}
    >
      <div className=" flex items-center justify-center">
        <div className="bg-white p-5 shadow-lg rounded-md relative w-auto">
          <button
            className="absolute top-0  right-[3px] w-[35px] h-[35px] flex items-center justify-center text-xl cursor-pointer"
            onClick={() => dispatch(hidePopup())}
          >
            <IoIosClose />
          </button>

          <div className="flex items-center justify-evenly mt-1">
            <div className="flex items-center justify-between gap-[10px] ">
              <div className="text-[17px] font-semibold">
              {message}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Popup;
